import { apiGet, apiPost, apiDelete } from './utils';

export interface RqJob {
  job_id: string;
  func_name: string;
  args: unknown[];
  kwargs: Record<string, unknown>;
  description: string | null;
  created_at: string | null;
  enqueued_at: string | null;
  started_at: string | null;
  ended_at: string | null;
  status: string;
  origin: string | null;
  meta: Record<string, unknown>;
  queue?: string;
  scheduled_time?: string;
  exc_info_truncated?: string;
  exc_info?: string;
}

export interface RqJobsResponse {
  jobs: RqJob[];
  total: number;
}

export const rqJobsApi = {
  async getScheduledJobs(limit?: number): Promise<RqJobsResponse> {
    return apiGet<RqJobsResponse>('/rq-jobs/scheduled', { limit });
  },

  async getFailedJobs(limit?: number): Promise<RqJobsResponse> {
    return apiGet<RqJobsResponse>('/rq-jobs/failed', { limit });
  },

  async getQueuedJobs(limit?: number): Promise<RqJobsResponse> {
    return apiGet<RqJobsResponse>('/rq-jobs/queued', { limit });
  },

  async getJobDetails(jobId: string): Promise<RqJob> {
    return apiGet<RqJob>(`/rq-jobs/${jobId}`);
  },

  async deleteJob(jobId: string): Promise<{ status: string; job_id: string }> {
    return apiDelete<{ status: string; job_id: string }>(`/rq-jobs/${jobId}`);
  },

  async requeueJob(jobId: string): Promise<{ status: string; job_id: string }> {
    return apiPost<{ status: string; job_id: string }>(`/rq-jobs/${jobId}/requeue`);
  },
};
